import script from "./Deals.vue?vue&type=script&setup=true&lang=js"
export * from "./Deals.vue?vue&type=script&setup=true&lang=js"

import "./Deals.vue?vue&type=style&index=0&id=f9e53026&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9e53026"]])

export default __exports__